module.exports = __webpack_public_path__ + "img/emoji.552db41.svg";